import { outfitMabActions } from "../actions/outfitting-mab";

const initialState = Object.freeze({
  openOutfits: [],
});

const outfittingMab = (state = initialState, action) => {
  switch (action.type) {
    case outfitMabActions.SET_OUTFIT_MABS: {
      return {
        ...state,
        openOutfits: action.payload,
      };
    }
    case outfitMabActions.CLEAR_OUTFIT_MABS: {
      return {
        ...state,
        openOutfits: [],
      };
    }
    case outfitMabActions.HYDRATE_OUTFIT_MAB: {
      return {
        ...state,
        openOutfits: action.payload,
      };
    }
    default:
      return state;
  }
};

export default outfittingMab;
